import React from 'react';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import WarningIcon from '@mui/icons-material/ReportProblemOutlined';
import { rows } from '../rows';
import { TestResults } from '../../../types';

const useStyles = makeStyles((theme: Theme) => ({
  close: {
    fill: theme.palette.error.main,
  },
  warning: {
    fill: theme.palette.warning.main,
  },
  check: {
    fill: theme.palette.success.main,
  },
}));

interface ResultIconProps {
  result?: TestResults;
}

export default function ResultIcon(props: ResultIconProps) {
  const classes = useStyles();
  const result = props.result;
  const hasError = Object.values(result?.errors ?? {}).length > 0;
  const hasWarning = result && rows.some((row) => row.getWarning?.(result));

  return (
    <>
      {hasError && <CloseIcon className={classes.close} />}
      {!hasError && hasWarning && <WarningIcon className={classes.warning} />}
      {!hasError && !hasWarning && <CheckIcon className={classes.check} />}
    </>
  );
}
